<section class="statistics-dq">
  <header class="statistics-dq__header">
    <i class="pi pi-list-check"></i>
    <h2>{{ 'statistics.dataQuality.title' | transloco }}</h2>
    <p>{{ 'statistics.dataQuality.subtitle' | transloco }}</p>
  </header>

  @if (!dataQuality.hasIssues) {
    <div class="statistics-dq__clean">
      <i class="pi pi-check-circle"></i>
      {{ 'statistics.dataQuality.noIssues' | transloco }}
    </div>
  } @else {
    <div class="statistics-dq__metrics">
      @for (metric of metrics; track metric.label) {
        <div class="statistics-dq__metric">
          <div class="statistics-dq__count">{{ metric.count | statCount }}</div>
          <div class="statistics-dq__label">{{ metric.label }}</div>
          @if (metric.scope) {
            <div class="statistics-dq__scope">{{ metric.scope }}</div>
          }
          <p class="statistics-dq__description">{{ metric.description }}</p>
        </div>
      }
    </div>

    <div class="statistics-dq__body">
      @if (categories.length) {
        <div class="statistics-dq__categories">
          <h3>{{ 'statistics.dataQuality.byCategoryTitle' | transloco }}</h3>
          @for (category of categories; track category.label) {
            <div class="statistics-dq__category">
              <span class="statistics-dq__category-label">{{ category.label }}</span>
              <span class="statistics-dq__track">
                <span class="statistics-dq__bar" [style.width.%]="category.percent"></span>
              </span>
              <strong class="statistics-dq__category-count">{{ category.count | statCount }}</strong>
            </div>
          }
        </div>
      }

      <div class="statistics-dq__animals">
        <h3>
          {{ 'statistics.dataQuality.affectedTitle' | transloco }}
          <span class="statistics-dq__caption">
            {{ 'statistics.dataQuality.affectedCaption' | transloco: {
              shown: visibleIds.length,
              total: dataQuality.affectedAnimalIds.length
            } }}
          </span>
        </h3>

        <div class="statistics-dq__chips">
          @for (id of visibleIds; track id) {
            <a class="statistics-dq__chip" [routerLink]="['/tiere', id]">
              <strong>{{ 'statistics.dataQuality.animal' | transloco: {id: id} }}</strong>
              <i class="pi pi-arrow-right"></i>
            </a>
          } @empty {
            <span class="statistics-dq__caption">{{ 'statistics.dataQuality.noAnimalIds' | transloco }}</span>
          }

          @if (hasMoreIds) {
            <button type="button" class="statistics-dq__more" (click)="showAll()">
              {{ 'statistics.dataQuality.showAll' | transloco: {count: dataQuality.affectedAnimalIds.length} }}
            </button>
          }
        </div>

        @if (dataQuality.affectedAnimalIdsTruncated) {
          <div class="statistics-dq__truncated">
            <i class="pi pi-info-circle"></i>
            {{ 'statistics.dataQuality.truncated' | transloco: {count: dataQuality.affectedAnimalIds.length} }}
          </div>
        }
      </div>
    </div>
  }
</section>
